import React from 'react';
import { RatioIframe } from './';

export const YoutubeEmbed = ({ id }) => (
  <RatioIframe
    src={`https://www.youtube.com/embed/${id}`}
    allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
  />
);
